import React, { useState, useRef } from 'react';
import {
    Grid,
    FormControl,
    Select,
    MenuItem,
    TextField,
    Button,
    Paper,
    Typography,
    Alert,
    Box,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    Card,
    CardContent,
    CardHeader,
    useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Visibility, Save as SaveIcon, Clear as ClearIcon, Send as SendIcon, Assignment as AssignmentIcon, Create as SignatureIcon } from '@mui/icons-material';
import TextareaAutosize from '@mui/base/TextareaAutosize';
import { EnviarCorreopdf, TareasProveedor, ingresoPDFWorkmanagerFlujo, TareasProveedorObseracion, ingresoDOCXWorkmanagerFlujo } from '../FunctionLogin'
import { generatePDF } from '../FuncionPDFen'
import SignatureCanvas from "react-signature-canvas";
import swal from 'sweetalert';
import PDFPreviewDialog from './PDFPreviewDialog';

// Generador de UUID alternativo si crypto.randomUUID no está disponible
function generateUUID() {
    if (window.crypto && window.crypto.randomUUID) {
        return window.crypto.randomUUID();
    }
    // fallback simple
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// --- Styled Components (Premium Glassmorphism) ---

const GlassContainer = styled(Paper)(({ theme }) => ({
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    borderRadius: '24px',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
    padding: theme.spacing(4),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto',
    border: '1px solid rgba(255, 255, 255, 0.18)',
}));

const StyledCard = styled(Card)(({ theme }) => ({
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '16px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
    marginBottom: theme.spacing(4),
    border: '1px solid rgba(0,0,0,0.05)'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    color: '#34495e',
    marginBottom: theme.spacing(2),
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontSize: '1.2rem',
    borderBottom: '2px solid #3f51b5',
    display: 'inline-block',
    paddingBottom: '4px'
}));

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
    backgroundColor: '#f8f9fa',
    color: '#2d3436',
    fontWeight: 700,
    borderBottom: '2px solid #e9ecef',
    textTransform: 'uppercase',
    fontSize: '0.85rem',
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
    fontSize: '0.9rem',
    borderBottom: '1px solid #f1f3f5',
}));

const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '50px',
    padding: '12px 28px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontSize: '1.1rem',
    boxShadow: '0 4px 14px 0 rgba(33,150,243,0.10)',
    transition: 'all 0.25s cubic-bezier(.4,2,.6,1)',
    background: 'linear-gradient(90deg, #1976d2 0%, #64b5f6 100%)',
    color: '#fff',
    '&:hover': {
        transform: 'scale(1.04) translateY(-2px)',
        boxShadow: '0 8px 24px 0 rgba(33,150,243,0.18)',
        background: 'linear-gradient(90deg, #1565c0 0%, #90caf9 100%)',
    },
    '&:active': {
        background: 'linear-gradient(90deg, #1976d2 0%, #64b5f6 100%)',
    },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        borderRadius: '12px',
        transition: 'all 0.3s cubic-bezier(.4,2,.6,1)',
        '& fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.1)',
        },
        '&:hover fieldset': {
            borderColor: theme.palette.primary.main,
            boxShadow: '0 0 0 2px #90caf9',
        },
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main,
            borderWidth: '2px',
            boxShadow: '0 4px 20px rgba(33,150,243,0.08)',
        },
        '&.Mui-focused': {
            backgroundColor: '#fff',
        }
    },
    '& .MuiInputLabel-root': {
        color: '#546e7a',
        fontWeight: 500,
    },
    '& .Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
    },
}));

export default function EvaluationVisita() {
    const isMobile = useMediaQuery('(max-width:600px)');
    const optionsContacto = [
        'SALES',
        'QUALITY',
        'INTERNATIONAL TRADE',
        'OTHER'
    ];


    const sigPad = useRef({});
    const sigPad2 = useRef({});
    const [rows, setRows] = useState([{
        contacto: 'SALES',
        nombre: '',
        telefono: '',
        email: '',
    },
    {
        contacto: 'QUALITY',
        nombre: '',
        telefono: '',
        email: '',
    },
    {
        contacto: 'INTERNATIONAL TRADE',
        nombre: '',
        telefono: '',
        email: '',
    }
        ,
    {
        contacto: 'OTHER',
        nombre: '',
        telefono: '',
        email: '',
    }]);


    const handleRowChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const options = [
        'NATIONAL TRANSPORTATION SERVICES',
        'IT SERVICES',
        'MECHANIZED OR METAL-MECHANICAL SERVICES',
        'CUSTOMS AGENCY SERVICES',
        'INTERNATIONAL TRANSPORTATION SERVICES',
        'PACKAGING SERVICES',
        'ENGINEERING SERVICES',
        'LEGAL SERVICES',
        'ACCOUNTING AND TAX SERVICES',
        'LOGISTICS SERVICES',
        'RAW MATERIALS SUPPLIES',
        'PACKAGING MATERIALS SUPPLIES',
        'SPARE PARTS SUPPLIES',
        'MACHINERY AND EQUIPMENT SUPPLIES FOR SALE',
        'CONSUMABLES AND ACCESSORIES SUPPLIES FOR SALE',
        'STORAGE'
    ];



    // Estados y validaciones para feedback visual
    const [fechaDiligenciamiento, setFechaDiligenciamiento] = useState('');
    const [fechaError, setFechaError] = useState(false);
    const [responsableVisita, setResponsableVisita] = useState('');
    const [responsableRecibir, setResponsableRecibir] = useState('');
    const [pais, setPais] = useState(localStorage.Pais);
    const [razonSocial, setRazonSocial] = useState(localStorage.Tproveedor);
    const [direccion, setDireccion] = useState(localStorage.Direcc);
    const [vinculosCiTalsa, setVinculosCiTalsa] = useState('');
    const [ciudad, setCiudad] = useState(localStorage.Ciudad);
    const [telefono, setTelefono] = useState(localStorage.Telefono);
    const [promedio, setPromedio] = useState('');
    const [opcionSeleccionada, setOpcionSeleccionada] = useState('');
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfBase64, setPdfBase64] = useState('');
    const [showPdfPreview, setShowPdfPreview] = useState(false);
    const [opcionSeleccionadaContacto, setOpcionSeleccionadaContacto] = useState('');
    const [razonError, setRazonError] = useState(false);
    const [telefonoError, setTelefonoError] = useState(false);
    const [direccionError, setDireccionError] = useState(false);
    const [ciudadError, setCiudadError] = useState(false);
    const [vinculosError, setVinculosError] = useState(false);
    const [promedioError, setPromedioError] = useState(false);
    const [opcionError, setOpcionError] = useState(false);
    const [paisError, setPaisError] = useState(false);

    const handleFechaDiligenciamientoChange = (event) => {
        setFechaDiligenciamiento(event.target.value);
    };

    const handlePaisChange = (event) => {
        setPais(event.target.value);
    };

    const handleRazonSocialChange = (event) => {
        setRazonSocial(event.target.value);
    };

    const handleDireccionChange = (event) => {
        setDireccion(event.target.value);
    };

    const handleVinculosCiTalsaChange = (event) => {
        setVinculosCiTalsa(event.target.value);
    };

    const handleCiudadChange = (event) => {
        setCiudad(event.target.value);
    };
    const handleTelefonoChangeChange = (event) => {
        setTelefono(event.target.value);
    };
    const handlePromedioChangeChange = (event) => {
        setPromedio(event.target.value);
    };

    const handleOpcionSeleccionadaContactoChange = (event) => {
        setOpcionSeleccionadaContacto(event.target.value);
    };
    const handleOpcionSeleccionadaChange = (event) => {
        setOpcionSeleccionada(event.target.value);
    };


    const handleResponsableVisitaChangeChange = (event) => {
        setResponsableVisita(event.target.value);
    };
    const handleResponsableRecibirChangeChange = (event) => {
        setResponsableRecibir(event.target.value);
    };



    const [comments, setComments] = useState(Array(60).fill(''));
    const [observacion, setObservacion] = useState(Array(60).fill(''));
    const [fecha, setFecha] = useState(Array(60).fill(''));

    const [observacionTotal, setObservacionTotal] = useState('');
    const [firmaFile, setFirmaFile] = useState(null); // Puede ser base64 o URL
    const [firmaFile2, setFirmaFile2] = useState(null);
    const [firmaFileLoading, setFirmaFileLoading] = useState(false);
    const [firmaFileError, setFirmaFileError] = useState(null);
    const [firmaFile2Loading, setFirmaFile2Loading] = useState(false);
    const [firmaFile2Error, setFirmaFile2Error] = useState(null);
    const [loading, setLoading] = useState(false);

    const evaluationData = [
        {
            category: 'FACILITIES',
            questions: [
                {
                    question: '1. Does the company have adequate and secure infrastructure to carry out its economic activity? (Check physical facilities)',
                    index: 0,
                },
                {
                    question: '2. Are the areas for handling, storage, loading, and unloading of goods properly delimited, and access is controlled for authorized personnel?',
                    index: 1,
                },
                {
                    question: '3. Does the company have monitoring centers both inside and outside the facilities to guarantee the security of the supplied product or service?',
                    index: 2,
                },
                {
                    question: '4. Does the company have an implemented surveillance and security system?',
                    index: 3,
                },
                {
                    question: '5. Do the company warehouses have secure enclosures to protect the merchandise?',
                    index: 4,
                },
                {
                    question: '6. Does the company have security personnel at the facilities?',
                    index: 5,
                },
                {
                    question: '7. Are there access controls to the facilities (people, vehicles)?',
                    index: 6,
                },
                {
                    question: '8. Are there procedures for cleaning, order, and disinfection of areas?',
                    index: 7,
                },
                {
                    question: '9. Is there a locative maintenance program?',
                    index: 8,
                },
                {
                    question: '10. Is there a pest control program?',
                    index: 9,
                },
            ],
        },
        {
            category: 'BUSINESS ASSOCIATE: SUPPLIERS',
            questions: [
                {
                    question: '1. Does the company have written processes for the evaluation and selection of business associates? If so, please provide the respective procedure code.',
                    index: 10,
                },
                {
                    question: '2. Is there evidence of control and management of supply and capabilities to meet order requirements?',
                    index: 11,
                },
                {
                    question: '3. Does the company have a business continuity and/or contingency plan?',
                    index: 12,
                },
                {
                    question: '4. Does it have a system to register, analyze, and address complaints and claims from business associates?',
                    index: 13,
                },
                {
                    question: '5. Does the company have all-risk insurance policies for the goods transported and stored that are owned by TALSA?',
                    index: 14,
                },
                {
                    question: '6. Are there tools in place to manage traceability and real-time monitoring of order delivery?',
                    index: 15,
                },
                {
                    question: '7. When subcontracting any of its critical processes related to the supply chain, does it conduct security studies on these business associates?',
                    index: 16,
                },
                {
                    question: '8. Is the personnel handling our shipments direct employees?',
                    index: 17,
                },
            ],
        },
        {
            category: 'PURCHASING',
            questions: [
                {
                    question: '1. Are there established controls in the receipt of materials and/or services?',
                    index: 18,
                },
                {
                    question: '2. Are there inspection, control, conformity testing, and/or disposition plans for materials and/or services?',
                    index: 19,
                },
                {
                    question: '3. Is the identification of purchased, accepted, rejected, and in-process materials adequate?',
                    index: 20,
                },
                {
                    question: '4. Does it have a system for the selection and evaluation of business associates to guarantee the security of the supply chain?',
                    index: 21,
                },
                {
                    question: '5. Are there provisions for the appropriate storage of raw materials, considering merchandise security measures? (e.g., contamination, theft, among others)',
                    index: 22,
                },
                {
                    question: '6. Are there implemented security measures aimed at mitigating risks in the supply chain (national or international)?',
                    index: 24,
                },
                {
                    question: '7. Are there documented procedures to ensure the integrity and security of the cargo in handling, storage, and transportation processes?',
                    index: 25,
                },
                {
                    question: '8. Are there documented procedures to ensure that dispatch or cargo reception information is accurate and protected against changes, losses, or input of erroneous data?',
                    index: 26,
                },
            ],
        },
        {
            category: 'PRODUCTION CONTROL, PERSONNEL SAFETY, AND SERVICE PROVISION',
            questions: [
                {
                    question: '1. Does it control and document the quality parameters of the process during production and/or service provision?',
                    index: 27,
                },
                {
                    question: '2. Does it conduct conformity tests on finished products and/or service quality as appropriate?',
                    index: 28,
                },
                {
                    question: '3. Does it properly identify the approved, rejected, and in-process finished product? For services, does it identify before, during, and after the provision of the service that meets the declared quality standards in its procedures?',
                    index: 29,
                },
                {
                    question: '4. Does it have provisions for handling non-conforming finished products? For services, does it have mechanisms for the management and continuous improvement of services that do not execute as agreed?',
                    index: 30,
                },
                {
                    question: '5. Does it have a preventive maintenance program and perform corrective maintenance on machinery or equipment used in the production or provision of services to TALSA? Please provide records confirming compliance.',
                    index: 31,
                },
                {
                    question: '6. Is there an implemented calibration, review, and maintenance program for measuring equipment associated with the quality of the products or services it sells?',
                    index: 32,
                },
                {
                    question: '7. Does it have technical data sheets and safety data sheets for the products it sells, or service level protocols for each of the services supplied to TALSA?',
                    index: 33,
                },
                {
                    question: '8. Are there procedures for the selection of personnel to join the company, including security measures?',
                    index: 34,
                },
            ],
        },
        {
            category: 'ENVIRONMENTAL MANAGEMENT',
            questions: [
                {
                    question: '1. Does it have an environmental management and sustainability policy?',
                    index: 35,
                },
                {
                    question: '2. Does your company have certificates, recognitions, or environmental management agreements? If so, which ones?',
                    index: 36,
                },
                {
                    question: '3. Does it have a matrix of environmental impacts within your organization? What are the most significant impacts?',
                    index: 37,
                },
                {
                    question: '4. Does it have action plans to mitigate environmental impacts, objectives, and goals?',
                    index: 38,
                },
                {
                    question: '5. Has it established procedures to address possible environmental emergencies related to its activity?',
                    index: 39,
                },
            ],
        },
        {
            category: 'SECURITY',
            questions: [
                {
                    question: '1. Does it have an implemented industrial safety and occupational health management system throughout its supply chain and foreign trade?',
                    index: 40,
                },
                {
                    question: '2. Does it control the packaging of its products?',
                    index: 41,
                },
                {
                    question: '3. Does the company control and record the distribution (transport) means of its products?',
                    index: 42,
                },
                {
                    question: '4. Does it properly identify products according to their hazardousness?',
                    index: 43,
                },
                {
                    question: '5. Does the company have a code of conduct for business associates or that includes this stakeholder group through which the values and principles of the company are transmitted?',
                    index: 44,
                },
                {
                    question: '6. Does it have a self-control system for the management, prevention, and control of risks associated with money laundering, terrorism financing (ML/TF), and other risks in its supply chain?',
                    index: 45,
                },
                {
                    question: '7. Does the company have records of the results of hazard identification and risk assessment and valuation, including routine and non-routine activities (HIRAV)?',
                    index: 46,
                },
            ],
        },
    ];


    const asociados = [
        { tipo: 'FAVORABLE', puntaje: '> 80', accion: 'Emphasize the strengths to maintain the position and the not-so-strong points to improve.', control: 'No verification required' },
        { tipo: 'CONDITIONALLY FAVORABLE', puntaje: '> 60 and <= 80', accion: 'Present the weak points for the associate to implement actions.', control: 'Eventual verification after three months' },
        { tipo: 'UNFAVORABLE', puntaje: '> 0 and <= 60', accion: 'The associate is informed that they have not met the expected parameters to continue having their services UNFAVORABLE.', control: 'Study the action plans submitted by the supplier' },
    ];


    const [evaluations, setEvaluations] = useState(Array(54).fill(0));

    const handleEvaluationChange = (index, value) => {
        setEvaluations((prevEvaluations) => {
            const newEvaluations = [...prevEvaluations];
            newEvaluations[index] = value;
            return newEvaluations;
        });
    };

    const [totalPoints, setTotalPoints] = useState(0);

    const sumPoints = () => {
        const sum = evaluations.reduce((total, evaluation) => total + evaluation, 0);
        setTotalPoints(sum);
    };


    const handleCommentChange = (index, value) => {
        setComments((prevComments) => {
            const newComments = [...prevComments];
            newComments[index] = value;
            return newComments;
        });
    };
    const handleObservacionChange = (index, value) => {
        setObservacion((prevComments) => {
            const newComments = [...prevComments];
            newComments[index] = value;
            return newComments;
        });
    };

    const handleFechaChange = (index, value) => {
        setFecha((prevComments) => {
            const newComments = [...prevComments];
            newComments[index] = value;
            return newComments;
        });
    };




    const evaluationRef = useRef(null);



    return (
        <GlassContainer ref={evaluationRef} elevation={3}>
            <Box sx={{ textAlign: "center", mb: 4 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#1a237e' }}>
                    VISIT BUSINESS ASSOCIATES
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                    Supplier Management
                </Typography>
            </Box>

            {/* Module 1: General Information */}
            <StyledCard elevation={0}>
                <CardHeader
                    title={<SectionTitle>General Information</SectionTitle>}
                    avatar={<AssignmentIcon color="primary" />}
                    sx={{ pb: 0 }}
                />
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="Filling Date"
                                type="date"
                                fullWidth
                                required
                                value={fechaDiligenciamiento}
                                onChange={e => {
                                    setFechaDiligenciamiento(e.target.value);
                                    setFechaError(e.target.value === '');
                                }}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="Country"
                                fullWidth
                                required
                                value={pais}
                                onChange={e => {
                                    setPais(e.target.value);
                                    setPaisError(e.target.value === '');
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="Company Name"
                                fullWidth
                                required
                                value={razonSocial}
                                onChange={e => {
                                    setRazonSocial(e.target.value);
                                    setRazonError(e.target.value === '');
                                }}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="Address"
                                fullWidth
                                required
                                value={direccion}
                                onChange={e => {
                                    setDireccion(e.target.value);
                                    setDireccionError(e.target.value === '');
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="City"
                                fullWidth
                                required
                                value={ciudad}
                                onChange={e => {
                                    setCiudad(e.target.value);
                                    setCiudadError(e.target.value === '');
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="Phone"
                                fullWidth
                                required
                                value={telefono}
                                onChange={e => {
                                    setTelefono(e.target.value);
                                    setTelefonoError(e.target.value === '');
                                }}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <StyledTextField
                                label="Years Linked with Talsa"
                                fullWidth
                                required
                                value={vinculosCiTalsa}
                                onChange={e => {
                                    setVinculosCiTalsa(e.target.value);
                                    setVinculosError(e.target.value === '');
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <StyledTextField
                                label="Average Purchases in the Last Year"
                                fullWidth
                                required
                                value={promedio}
                                onChange={e => {
                                    setPromedio(e.target.value);
                                    setPromedioError(e.target.value === '');
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <StyledTextField
                                    select
                                    label="Product or Services Supplied to the Company"
                                    value={opcionSeleccionada}
                                    onChange={e => {
                                        setOpcionSeleccionada(e.target.value);
                                        setOpcionError(e.target.value === '');
                                    }}
                                    variant="outlined"
                                >
                                    {options.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </StyledTextField>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>


            <TableContainer component={Paper} elevation={0} sx={{ mb: 4, borderRadius: 2, border: '1px solid #e0e0e0' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCellHead>CONTACT</StyledTableCellHead>
                            <StyledTableCellHead>NAME</StyledTableCellHead>
                            <StyledTableCellHead>PHONE</StyledTableCellHead>
                            <StyledTableCellHead>EMAIL</StyledTableCellHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={index} hover>
                                <StyledTableCellBody>
                                    <Select
                                        value={row.contacto}
                                        fullWidth
                                        variant="standard"
                                        disableUnderline
                                        onChange={(e) => handleRowChange(index, 'contacto', e.target.value)}
                                    >
                                        {optionsContacto.map((option) => (
                                            <MenuItem key={option} value={option}>{option}</MenuItem>
                                        ))}
                                    </Select>
                                </StyledTableCellBody>
                                <StyledTableCellBody>
                                    <StyledTextField
                                        fullWidth
                                        variant="standard"
                                        value={row.nombre}
                                        onChange={(e) => handleRowChange(index, 'nombre', e.target.value)}
                                        InputProps={{ disableUnderline: true }}
                                    />
                                </StyledTableCellBody>
                                <StyledTableCellBody>
                                    <StyledTextField
                                        fullWidth
                                        variant="standard"
                                        value={row.telefono}
                                        onChange={(e) => handleRowChange(index, 'telefono', e.target.value)}
                                        InputProps={{ disableUnderline: true }}
                                    />
                                </StyledTableCellBody>
                                <StyledTableCellBody>
                                    <StyledTextField
                                        fullWidth
                                        variant="standard"
                                        value={row.email}
                                        onChange={(e) => handleRowChange(index, 'email', e.target.value)}
                                        InputProps={{ disableUnderline: true }}
                                    />
                                </StyledTableCellBody>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>


            </TableContainer>
            <TableContainer component={Paper} style={{ width: "100%", border: "1px solid", margin: "auto", padding: "0px" }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <h4>SCORING SYSTEM</h4>
                            </TableCell>
                            <TableCell>
                                <h4>Category</h4>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                1
                            </TableCell>
                            <TableCell>
                                Does not meet
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                2
                            </TableCell>
                            <TableCell>
                                Partially meets
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                3
                            </TableCell>
                            <TableCell>
                                Meets
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>


            <TableContainer component={Paper} elevation={0} sx={{ maxHeight: "600px", maxWidth: "100%", overflowY: "auto", border: '1px solid #e0e0e0', borderRadius: 2 }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <StyledTableCellHead>Category</StyledTableCellHead>
                            <StyledTableCellHead>Questions</StyledTableCellHead>
                            <StyledTableCellHead align="center">Evaluation</StyledTableCellHead>
                            <StyledTableCellHead>Comments</StyledTableCellHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {evaluationData.map((category, categoryIndex) => (
                            <React.Fragment key={categoryIndex}>
                                {category.questions.map((question, questionIndex) => (
                                    <TableRow key={`${categoryIndex}-${questionIndex}`}>
                                        {questionIndex === 0 && (
                                            <StyledTableCellBody
                                                sx={{ fontWeight: 'bold', backgroundColor: '#fafafa', borderRight: '1px solid #eee' }}
                                                rowSpan={category.questions.length}
                                            >
                                                {category.category}
                                            </StyledTableCellBody>
                                        )}
                                        <StyledTableCellBody sx={{ width: '40%' }}>
                                            {question.question}
                                        </StyledTableCellBody>
                                        <StyledTableCellBody align="center">
                                            <FormControl fullWidth variant="outlined" size="small">
                                                <Select
                                                    value={evaluations[question.index] || ''}
                                                    onChange={(event) => handleEvaluationChange(question.index, event.target.value)}
                                                    sx={{ minWidth: 80, height: 40, background: '#f5faff', borderRadius: 2, fontWeight: 600 }}
                                                    displayEmpty
                                                    MenuProps={{
                                                        PaperProps: {
                                                            sx: {
                                                                bgcolor: '#e3f2fd',
                                                                color: '#1565c0',
                                                                fontWeight: 700,
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em></em>
                                                    </MenuItem>
                                                    <MenuItem value={1}>1 (No)</MenuItem>
                                                    <MenuItem value={2}>2 (Partial)</MenuItem>
                                                    <MenuItem value={3}>3 (Yes)</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </StyledTableCellBody>
                                        <StyledTableCellBody sx={{ width: '30%' }}>
                                            <StyledTextField
                                                fullWidth
                                                size="small"
                                                placeholder="General comment"
                                                value={comments[question.index] || ''}
                                                onChange={(event) => handleCommentChange(question.index, event.target.value)}
                                                sx={{ mb: 1 }}
                                            />

                                            {/* Conditional Fields based on Evaluation */}
                                            {evaluations[question.index] === 1 && (
                                                <Box sx={{ mt: 1, p: 1, bgcolor: '#fff3e0', borderRadius: 1 }}>
                                                    <Typography variant="caption" color="warning.main" fontWeight="bold">
                                                        comment Required:
                                                    </Typography>
                                                    <StyledTextField
                                                        fullWidth
                                                        multiline
                                                        rows={2}
                                                        size="small"
                                                        placeholder="Describe the non-conformity"
                                                        value={observacion[question.index] || ''}
                                                        onChange={(event) => handleObservacionChange(question.index, event.target.value)}
                                                        sx={{ mt: 0.5, mb: 1 }}
                                                    />
                                                    <StyledTextField
                                                        type="date"
                                                        fullWidth
                                                        size="small"
                                                        label="Commitment Date"
                                                        InputLabelProps={{ shrink: true }}
                                                        value={fecha[question.index] || ''}
                                                        onChange={(event) => handleFechaChange(question.index, event.target.value)}
                                                    />
                                                </Box>
                                            )}
                                        </StyledTableCellBody>

                                    </TableRow>
                                ))}
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>



            <Box sx={{ mb: 4 }}>
                <Typography variant="h6" gutterBottom color="textSecondary">General Comments</Typography>
                <StyledTextField
                    fullWidth
                    multiline
                    rows={4}
                    value={observacionTotal}
                    onChange={(e) => setObservacionTotal(e.target.value)}
                    variant="outlined"
                    placeholder="Enter general comments about the total evaluation..."
                />
            </Box>

            {/* Module 2: Evaluation Results */}
            <StyledCard elevation={0}>
                <CardHeader
                    title={<SectionTitle>Result of Evaluation</SectionTitle>}
                    sx={{ pb: 0 }}
                />
                <CardContent>
                    <Typography style={{ fontWeight: "bold", color: "red", marginBottom: '16px' }}>
                        Note: All items with comments must have an action plan, which must be documented within the next three (3) months.
                    </Typography>

                    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0', borderRadius: 2 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCellHead>Qualification</StyledTableCellHead>
                                    <StyledTableCellHead>Score</StyledTableCellHead>
                                    <StyledTableCellHead>Action to Follow</StyledTableCellHead>
                                    <StyledTableCellHead>Control</StyledTableCellHead>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {asociados.map((asociado, index) => (
                                    <TableRow key={index} hover>
                                        <StyledTableCellBody sx={{ fontWeight: 'bold' }}>{asociado.tipo}</StyledTableCellBody>
                                        <StyledTableCellBody>{asociado.puntaje}</StyledTableCellBody>
                                        <StyledTableCellBody>{asociado.accion}</StyledTableCellBody>
                                        <StyledTableCellBody>{asociado.control}</StyledTableCellBody>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box sx={{ mt: 3, p: 2, bgcolor: '#e8f5e9', borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Typography variant="h6" color="success.dark" gutterBottom>
                            FINAL SCORE: <strong>{((totalPoints / 162) * 100).toFixed(2)} %</strong>
                        </Typography>
                        <Chip
                            label={
                                (((totalPoints / 162) * 100).toFixed(2) > 80 ? "FAVORABLE" : ((totalPoints / 162) * 100).toFixed(2) > 60
                                    && ((totalPoints / 162) * 100).toFixed(2) <= 80 ? "CONDITIONALLY FAVORABLE" : "UNFAVORABLE")
                            }
                            color={
                                (((totalPoints / 162) * 100).toFixed(2) > 80 ? "success" : ((totalPoints / 162) * 100).toFixed(2) > 60
                                    && ((totalPoints / 162) * 100).toFixed(2) <= 80 ? "warning" : "error")
                            }
                            sx={{ fontWeight: 'bold', fontSize: '1rem', px: 2 }}
                        />
                    </Box>
                </CardContent>
            </StyledCard>


            {/* Module 3: Signatures */}
            <StyledCard elevation={0} sx={{ border: '1px solid #bbdefb' }}>
                <CardHeader
                    title={<SectionTitle>Signatures & Approval</SectionTitle>}
                    avatar={<SignatureIcon color="primary" />}
                />
                <CardContent>
                    <Grid container spacing={4} justifyContent="center" alignItems="stretch">
                        {/* Signature 1 */}
                        <Grid item xs={12} md={6}>
                            <Paper elevation={0} sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#fafafa' }}>
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom color="primary">
                                    RESPONSIBLE FOR EXECUTING THE VISIT
                                </Typography>
                                <StyledTextField
                                    label="Full Name"
                                    fullWidth
                                    variant="standard"
                                    sx={{ mb: 3 }}
                                    value={responsableVisita}
                                    onChange={(e) => setResponsableVisita(e.target.value)}
                                />
                                <Box sx={{ border: '2px solid #bdbdbd', borderRadius: 1, overflow: 'hidden', bgcolor: '#fff' }}>
                                    <SignatureCanvas
                                        canvasProps={{
                                            width: 400,
                                            height: 180,
                                            className: 'sigCanvas',
                                        }}
                                        ref={sigPad}
                                    />
                                </Box>
                                <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                                    <Button variant="outlined" startIcon={<ClearIcon />} color="error" size="small" onClick={() => { sigPad.current.clear(); setFirmaFile(null); setFirmaFileError(null); }}>
                                        Clear
                                    </Button>
                                    <Button
                                        variant="contained"
                                        startIcon={<SaveIcon />}
                                        color="primary"
                                        size="small"
                                        disabled={firmaFileLoading}
                                        onClick={async () => {
                                            sumPoints();
                                            setFirmaFileLoading(true);
                                            setFirmaFileError(null);
                                            try {
                                                const canvas = sigPad.current.getCanvas();
                                                const dataUrl = canvas.toDataURL("image/png");
                                                const base64 = dataUrl.split(",")[1];
                                                const nombreArchivo = `firma_${generateUUID()}.png`;
                                                const body = {
                                                    base64: `data:image/png;base64,${base64}`,
                                                    nombreArchivo,
                                                    tipoArchivo: "image/png"
                                                };
                                                const response = await fetch("https://consumos.talsa.com.co/api/talsa/proveedores/img-proveedor", {
                                                    method: "POST",
                                                    headers: {
                                                        "Content-Type": "application/json"
                                                    },
                                                    body: JSON.stringify(body)
                                                });
                                                let result = null;
                                                try {
                                                    result = await response.json();
                                                } catch (jsonErr) {
                                                    setFirmaFileError("Invalid server response. CORS or network error?");
                                                    console.error("Non-JSON response:", jsonErr, response);
                                                    return;
                                                }
                                                console.log("Signature response:", result);
                                                if (result && result.success && result.url) {
                                                    setFirmaFile(result.url);
                                                    swal("Saved", "Signature saved", "success");
                                                } else {
                                                    setFirmaFileError("Could not save signature. " + (result && result.message ? result.message : "Try again."));
                                                    console.error("Error in signature response:", result);
                                                }
                                            } catch (err) {
                                                setFirmaFileError("Error uploading signature: " + (err && err.message ? err.message : err));
                                                console.error("Network error uploading signature:", err);
                                            } finally {
                                                setFirmaFileLoading(false);
                                            }
                                        }}
                                    >
                                        {firmaFileLoading ? "Saving..." : "Save"}
                                    </Button>
                                    {firmaFileError && (
                                        <Alert severity="error" sx={{ mt: 1 }}>{firmaFileError}</Alert>
                                    )}
                                </Box>
                            </Paper>
                        </Grid>

                        {/* Signature 2 */}
                        <Grid item xs={12} md={6}>
                            <Paper elevation={0} sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#fafafa' }}>
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom color="primary">
                                    RESPONSIBLE FOR RECEIVING THE VISIT
                                </Typography>
                                <StyledTextField
                                    label="Full Name"
                                    fullWidth
                                    variant="standard"
                                    sx={{ mb: 3 }}
                                    value={responsableRecibir}
                                    onChange={(e) => setResponsableRecibir(e.target.value)}
                                />
                                <Box sx={{ border: '2px solid #bdbdbd', borderRadius: 1, overflow: 'hidden', bgcolor: '#fff' }}>
                                    <SignatureCanvas
                                        canvasProps={{
                                            width: 400,
                                            height: 180,
                                            className: 'sigCanvas',
                                        }}
                                        ref={sigPad2}
                                    />
                                </Box>
                                <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                                    <Button variant="outlined" startIcon={<ClearIcon />} color="error" size="small" onClick={() => { sigPad2.current.clear(); setFirmaFile2(null); setFirmaFile2Error(null); }}>
                                        Clear
                                    </Button>
                                    <Button
                                        variant="contained"
                                        startIcon={<SaveIcon />}
                                        color="primary"
                                        size="small"
                                        disabled={firmaFile2Loading}
                                        onClick={async () => {
                                            sumPoints();
                                            setFirmaFile2Loading(true);
                                            setFirmaFile2Error(null);
                                            try {
                                                const canvas = sigPad2.current.getCanvas();
                                                const dataUrl = canvas.toDataURL("image/png");
                                                const base64 = dataUrl.split(",")[1];
                                                const nombreArchivo = `firma_${generateUUID()}.png`;
                                                const body = {
                                                    base64: `data:image/png;base64,${base64}`,
                                                    nombreArchivo,
                                                    tipoArchivo: "image/png"
                                                };
                                                const response = await fetch("https://consumos.talsa.com.co/api/talsa/proveedores/img-proveedor", {
                                                    method: "POST",
                                                    headers: {
                                                        "Content-Type": "application/json"
                                                    },
                                                    body: JSON.stringify(body)
                                                });
                                                let result = null;
                                                try {
                                                    result = await response.json();
                                                } catch (jsonErr) {
                                                    setFirmaFile2Error("Invalid server response. CORS or network error?");
                                                    console.error("Non-JSON response:", jsonErr, response);
                                                    return;
                                                }
                                                console.log("Signature2 response:", result);
                                                if (result && result.success && result.url) {
                                                    setFirmaFile2(result.url);
                                                    swal("Saved", "Signature saved", "success");
                                                } else {
                                                    setFirmaFile2Error("Could not save signature. " + (result && result.message ? result.message : "Try again."));
                                                    console.error("Error in signature2 response:", result);
                                                }
                                            } catch (err) {
                                                setFirmaFile2Error("Error uploading signature: " + (err && err.message ? err.message : err));
                                                console.error("Network error uploading signature2:", err);
                                            } finally {
                                                setFirmaFile2Loading(false);
                                            }
                                        }}
                                    >
                                        {firmaFile2Loading ? "Saving..." : "Save"}
                                    </Button>
                                    {firmaFile2Error && (
                                        <Alert severity="error" sx={{ mt: 1 }}>{firmaFile2Error}</Alert>
                                    )}
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>
            <Alert severity="warning" sx={{ mb: 3 }}>
                You must sign the form and save the signature before sending the information.
            </Alert>

            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
                <StyledButton
                    variant="contained"
                    color="primary"
                    size="large"
                    endIcon={<SendIcon />}
                    sx={{
                        background: 'linear-gradient(90deg, #43cea2 0%, #185a9d 100%)',
                        fontSize: '1.1rem',
                        px: 5,
                        py: 2,
                        boxShadow: '0 8px 24px 0 rgba(33,150,243,0.18)',
                        '&:hover': {
                            background: 'linear-gradient(90deg, #185a9d 0%, #43cea2 100%)',
                        }
                    }}
                    onClick={() => {
                        const tableData = [];
                        // Recorrer las filas de la tabla
                        evaluationData.forEach((category, categoryIndex) => {
                            const categoryData = {
                                category: category.category,
                                questions: [],
                            };
                            category.questions.forEach((question, questionIndex) => {
                                // Obtener los valores de la pregunta, evaluación, comentario y observación
                                const questionData = {
                                    question: question.question,
                                    evaluation: evaluations[question.index] || "",
                                    comment: comments[question.index] || "",
                                    observation: observacion[question.index] || "",
                                    fecha: fecha[question.index] || "",
                                };
                                // Agregar los valores al array de preguntas
                                categoryData.questions.push(questionData);
                            });
                            // Agregar los datos de la categoría al array principal
                            tableData.push(categoryData);
                        });

                        const camposRequeridos = [
                            { campo: 'fechaDiligenciamiento', valor: fechaDiligenciamiento, mensaje: 'Filing date' },
                            { campo: 'pais', valor: pais, mensaje: 'Country' },
                            { campo: 'razonSocial', valor: razonSocial, mensaje: 'Company name' },
                            { campo: 'direccion', valor: direccion, mensaje: 'Address' },
                            { campo: 'ciudad', valor: ciudad, mensaje: 'City' },
                            { campo: 'telefono', valor: telefono, mensaje: 'Phone' },
                            { campo: 'vinculosCiTalsa', valor: vinculosCiTalsa, mensaje: 'Time linked with Talsa' },
                            { campo: 'promedio', valor: promedio, mensaje: 'Purchases in the last year' },
                            { campo: 'opcionSeleccionada', valor: opcionSeleccionada, mensaje: 'Supplies' },
                        ];

                        let errorFound = false;
                        camposRequeridos.forEach(campo => {
                            if (!campo.valor || campo.valor.trim() === '') {
                                errorFound = true;
                            }
                        });
                        if (errorFound) {
                            swal({
                                title: 'The document must be signed!',
                                text: `Faltan campos obligatorios. Por favor revise los campos resaltados en rojo.`,
                                icon: 'warning',
                            });
                            setFechaError(fechaDiligenciamiento === '');
                            setRazonError(razonSocial === '');
                            setTelefonoError(telefono === '');
                            setDireccionError(direccion === '');
                            setCiudadError(ciudad === '');
                            setVinculosError(vinculosCiTalsa === '');
                            setPromedioError(promedio === '');
                            setOpcionError(opcionSeleccionada === '');
                            setPaisError(pais === '');
                            setLoading(false);
                            return false;
                        }

                        if (firmaFile == null || firmaFile2 == null) {
                            swal("Document must be signed!", "Please validate the information!", "warning");
                            return;
                        }

                        setLoading(true);

                        // Google Apps Script Integration
                        const appScriptData = {
                            "fechadilencia": fechaDiligenciamiento,
                            "pais": pais,
                            "razonsocial": razonSocial,
                            "telefono": telefono,
                            "direccion": direccion,
                            "tiempotalsa": vinculosCiTalsa,
                            "ciudad": ciudad,
                            "comprasultimosano": promedio,
                            "servicioquesuministra": opcionSeleccionada,
                            "observacionestotal": observacionTotal,
                            "puntosobtenidos": totalPoints.toString(),
                            "puntosposibles": (evaluations.length * 3).toString(), // Note: evaluations length might differ
                            "preguntasaplicables": evaluations.length.toString(),
                            "calificacion": `${((totalPoints / (evaluations.length * 3)) * 100).toFixed(2)}%`,
                            "responsable1": responsableVisita,
                            "responsable2": responsableRecibir,
                            "firma1": firmaFile,
                            "firma2": firmaFile2
                        };

                        // Add contacts (max 4 as per requested JSON)
                        rows.forEach((row, i) => {
                            if (i < 4) {
                                appScriptData[`nombre${i + 1}`] = row.nombre || "";
                                appScriptData[`telefono${i + 1}`] = row.telefono || "";
                                appScriptData[`email${i + 1}`] = row.email || "";
                            }
                        });


                        // Map all questions
                        let qNum = 1;
                        evaluationData.forEach(category => {
                            category.questions.forEach(question => {
                                const idx = question.index;
                                appScriptData[`evaluacion${qNum}`] = evaluations[idx] ? evaluations[idx].toString() : "";
                                appScriptData[`comentario${qNum}`] = comments[idx] || "";
                                appScriptData[`observaciones${qNum}`] = observacion[idx] || "";
                                appScriptData[`fecha${qNum}`] = fecha[idx] || "";
                                qNum++;
                            });
                        });

                        const appScriptUrl = "https://script.google.com/macros/s/AKfycbx6x6xiQwYYqHjtD_DJNlubuwaSwKKBqcHuj6nzJsI6wqROPrS4qPncPzc_lVwCSUuoug/exec";

                        fetch(appScriptUrl, {
                            method: 'POST',
                            headers: {
                                "Content-Type": "text/plain;charset=utf-8"
                            },
                            body: JSON.stringify(appScriptData)
                        })
                            .then(response => response.json())
                            .then(result => {
                                setLoading(false);
                                console.log("Server response:", result);

                                swal("Success", "Evaluation sent successfully", "success");

                                // Extraer la URL del PDF de la respuesta
                                if (result && result.pdf && result.pdf.url) {
                                    console.log("📄 URL del PDF recibida:", result.pdf.url);
                                    setPdfUrl(result.pdf.url);

                                    // Generar base64 localmente para el envío por correo sin fallos de CORS
                                    const calificacionFinal = `${((totalPoints / (evaluations.length * 3)) * 100).toFixed(2)}%`;
                                    generatePDF(fechaDiligenciamiento, rows, tableData, calificacionFinal, firmaFile, firmaFile2, pais, razonSocial, telefono, direccion, vinculosCiTalsa, ciudad, promedio, opcionSeleccionada, responsableVisita, responsableRecibir).then(base64 => {
                                        setPdfBase64(base64);
                                        setShowPdfPreview(true);
                                    }).catch(err => {
                                        console.error("Error al generar PDF local:", err);
                                        setShowPdfPreview(true); // Mostrar de todos modos aunque falle la generación local
                                    });
                                } else {
                                    console.warn("⚠️ No se recibió URL del PDF en la respuesta");
                                }
                            })
                            .catch(e => {
                                console.error("Error App Script:", e);
                                setLoading(false);
                                swal("Error", "Could not send evaluation", "error");
                            });
                    }}

                >
                    {loading ? "Sending..." : "Send information"}
                </StyledButton>
            </Box >

            {/* PDF Preview Dialog */}
            <PDFPreviewDialog
                open={showPdfPreview}
                pdfUrl={pdfUrl}
                pdfBase64={pdfBase64}
                onClose={() => setShowPdfPreview(false)}
                title="PDF Preview - Supplier Visit Evaluation"
                supplierName={razonSocial}
                evaluationType="Supplier Visit Evaluation"
            />

        </GlassContainer >
    );
}
